export const styles = {
  headingApp: {
    fontSize: "32px",
    fontWeight: "bold",
  },
  searchTextfield: {
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #FAFAFA",
    background: "#FAFAFA",
  },
};
